export default __webpack_public_path__ + "static/media/objectstorage_openapi.27d51bf8.yaml";